import React from "react";
import { Stack, Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import ErrorOutlineIcon from "@mui/icons-material/Error";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";

const ChatMessageDecryptFailed = ({ isMine = false }) => {
  const classes = useStyles({ isMine });
  const { t: getLabel } = useTranslation(LangConstant.NS_HOME_CONVERSATION);

  return (
    <Stack direction="row" alignItems="center" className={clsx(classes.decryptingBox)}>
      <Box className={clsx(classes.iconLoad)}>
        <ErrorOutlineIcon />
      </Box>
      <Typography className={clsx(classes.decrypting)}>{getLabel("TXT_DECRYPTING_FAIL")}</Typography>
    </Stack>
  );
};

export default ChatMessageDecryptFailed;

const useStyles = makeStyles({
  decryptingBox: {
    padding: "12px 16px",
    display: "flex",
  },
  iconLoad: {
    color: "#FF2C28",
    fontSize: 24,
  },
  "@keyframes rotateReverse": {
    from: {
      transform: "rotate(0deg)",
    },
    to: {
      transform: "rotate(-360deg)",
    },
  },
  decrypting: {
    paddingLeft: "8px",
    fontSize: 14,
    color: "#FF2C28",
    fontWeight: 500,
    lineHeight: "20px",
  },
});
